import React, { useContext, useEffect, useState } from "react";
import LangContext from "../../../context/LangContext";
import LanguageService from "../../../services/Language.service";
import { json } from "stream/consumers";

const Languages = ({ scrollActive }: { scrollActive?: boolean }) => {
  const { lang, setLang } = useContext(LangContext);
  const [languages, setLanguages] = useState<langsType[]>([]);
  const [activeLang, setActiveLang] = useState(lang);

  const handleLangChange = (lang: langsType) => {
    localStorage.setItem("lang", JSON.stringify(lang));
    setActiveLang(lang.lang_code);
    setLang(lang);
  };

  const fetchLangs = async () => {
    try {
      const res = await LanguageService.fetchLanguages();
      setLanguages(res.data.languages);

      const localActiveLang = localStorage.getItem("lang");

      if (localActiveLang) {
        setLang(JSON.parse(localActiveLang));
        setActiveLang(JSON.parse(localActiveLang).lang_code);
      } else {
        setLang(res.data.languages[0]);
        setActiveLang(res.data.languages[0].lang_code);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchLangs();
    // createScrollNavEffect();
  }, []);

  return (
    <div className="relative flex items-center space-x-2">
      {languages.map((item, i) => (
        <span
          key={i}
          className={`border  py-1 cursor-pointer text-center w-9 capitalize ${
            activeLang === item.lang_code
              ? scrollActive
                ? "bg-secondary-base text-primary-base"
                : "bg-primary-base"
              : ""
          }`}
          onClick={() => handleLangChange(item)}
        >
          {item.lang_code}
        </span>
      ))}
    </div>
  );
};

export default Languages;
